module.exports = __webpack_public_path__ + "img/video_thumb.5256960c.png";